import { Observable } from 'rxjs';

import { Snapshot, SnapshotCreateParams } from '../models/snapshot.model';

export abstract class SnapshotGateway {
  abstract createSnapshot(channelId: string, params: SnapshotCreateParams): Observable<Snapshot>;
}
